import { render } from "./contactSecond.vue?vue&type=template&id=70254870&scoped=true"
import script from "./contactSecond.vue?vue&type=script&lang=js"
export * from "./contactSecond.vue?vue&type=script&lang=js"

import "./contactSecond.vue?vue&type=style&index=0&id=70254870&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70254870"]])

export default __exports__